/* istanbul ignore file */
// we don't test SVGs without arguments
import React from 'react'

const CreateClassIcon = props => {
  return (
    <svg
      fill="none"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Create Class</title>
      <circle cx="9" cy="9" r="9" fill="currentColor" />
      <path
        d="M4.90869 9.00089H13.0905"
        stroke="white"
        strokeLinecap="round"
        strokeWidth="2.04545"
      />
      <path
        d="M9.0004 4.9082V13.09"
        stroke="white"
        strokeLinecap="round"
        strokeWidth="2.04545"
      />
    </svg>
  )
}

export default CreateClassIcon
